import CircularProgress from '@material-ui/core/CircularProgress'
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

interface IPropsType {
  rootStyle?: string
  spinning?: boolean
  children: React.ReactNode
}

const SpinRoot = styled.div<{
  rootStyle: string
}>`
  position: relative;
  display: inline-block;
  ${({ rootStyle }) => rootStyle}
`

const SpinProgress = styled.div<{
  offsetX: string
  offsetY: string
}>`
  position: absolute;
  top: 0px;
  left: 0px;
  display: block;
  width: 100%;
  height: 100%;

  & > div {
    position: absolute;
    top: ${({ offsetY }) => offsetY};
    left: ${({ offsetX }) => offsetX};
    margin: -20px;
  }
`

const SpinContainer = styled.div<{
  spinning: boolean
}>`
  display: inline-block;
  transition: opacity 0.3s;

  ${({ spinning }) =>
    !spinning
      ? ''
      : `
    opacity: 0.5;
    user-select: none;
    pointer-events: none;
  `}
`

const Spin = ({ rootStyle = '', spinning = true, children }: IPropsType) => {
  const rootRef = useRef<HTMLDivElement | null>(null)
  const rootgBoundingClientRect = rootRef.current?.getBoundingClientRect()
  const offsetX =
    (rootgBoundingClientRect?.width || 0) > window.innerWidth ? '50vw' : '50%'
  const offsetY =
    (rootgBoundingClientRect?.height || 0) > window.innerHeight ? '50vh' : '50%'
  const [, setForceUpdate] = useState(false)

  useEffect(() => {
    setForceUpdate(true)
  }, [])

  return (
    <SpinRoot ref={rootRef} rootStyle={rootStyle}>
      {!spinning ? null : (
        <div>
          <SpinProgress offsetX={offsetX} offsetY={offsetY}>
            <CircularProgress />
          </SpinProgress>
        </div>
      )}

      <SpinContainer spinning={spinning}>{children}</SpinContainer>
    </SpinRoot>
  )
}

export default React.memo(Spin) as unknown as typeof Spin
